export { COOKIE_NAME, ONE_YEAR_MS } from "@shared/const";

// Generate login URL at runtime so redirect URI reflects the current origin.
export const getLoginUrl = () => {
  const oauthPortalUrl = import.meta.env.VITE_OAUTH_PORTAL_URL || 'https://manus.im';
  const appId = import.meta.env.VITE_APP_ID || 'VMVQ3MrSC8LnpxVFdVtZci';
  
  // Use the Manus-provided custom domain for OAuth redirect URI
  // This ensures the redirect URI is whitelisted in the OAuth app configuration
  // The custom domain works in both development and production environments
  const redirectUri = `https://igetgeo-vmvq3mrs.manus.space/api/oauth/callback`;
  
  // Encode both the redirect URI and the original browser origin in state
  // This allows the backend to redirect back to the correct domain after setting the cookie
  const stateData = {
    redirectUri,
    returnOrigin: window.location.origin
  };
  const state = btoa(JSON.stringify(stateData));

  try {
    const url = new URL(`${oauthPortalUrl}/app-auth`);
    url.searchParams.set("appId", appId);
    url.searchParams.set("redirectUri", redirectUri);
    url.searchParams.set("state", state);
    // Note: The state parameter now contains both redirectUri and returnOrigin
    // Backend will decode this to redirect back to the original browser domain
    url.searchParams.set("type", "signIn");

    return url.toString();
  } catch (error) {
    console.error('[getLoginUrl] Error constructing URL:', error);
    // Fallback URL
    return `${oauthPortalUrl}/app-auth?appId=${appId}&redirectUri=${encodeURIComponent(redirectUri)}&state=${encodeURIComponent(state)}&type=signIn`;
  }
};
